exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-dialog-content {\n  height: 140px; }\n\n.enabled-button {\n  color: #4b81b0; }\n\n.disabled-button {\n  color: #9e9e9e; }\n\n.error-tag {\n  color: red;\n  float: left;\n  margin-left: 5px;\n  margin-top: -17px;\n  font-size: 12px;\n  overflow: visible; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/abm/new-edit-producto-dialog/new-edit-producto-dialog.component.scss
// module id = ../../../../../src/app/components/abm/new-edit-producto-dialog/new-edit-producto-dialog.component.scss
// module chunks = 0